import axios from "axios";

const multipartHeader = {
	headers: {
		"content-type": "multipart/form-data",
	},
};

async function salesforceBankServiceGet() {
	const baseUrl = process.env.VUE_APP_BASE_URL;
	let formData = new FormData();

	return await axios.post(baseUrl + "?class=Bank&method=getSalesforceBankOptions", formData, multipartHeader);
}

export default salesforceBankServiceGet;
